import { UserOutlined } from '@ant-design/icons';

import SigninPage from '../pages/SigninPage';
import UserPage from '../pages/UserPage';

import { SiteMap } from './index';

export const userRoutes: SiteMap = {
  user: {
    title: '사용자 관리',
    page: UserPage,
    icon: <UserOutlined />,
    key: '/user',
    children: [
      {
        label: '모든 사용자',
        icon: null,
        key: '/user/all',
      },
      {
        label: '사용자 상세',
        icon: null,
        key: '/user/detail',
      },
      {
        label: '직원 관리',
        icon: null,
        key: '/user/staff',
        role: ['admin'],
      },
    ],
  },
  login: {
    title: '로그인',
    page: SigninPage,
    key: '/login',
    icon: undefined,
  },
};
